<div class="content" >
  <div  class="description-banner">
    <ngx-skeleton-loader
      appearance="line"
      [theme]="{
        height: '35px'
      }"
    ></ngx-skeleton-loader>
  </div>
  <div class="progress-bar-container">
    <ngx-skeleton-loader
      appearance="line"
      [theme]="{
        height: '20px'
      }"
    ></ngx-skeleton-loader>
  </div>
  <div class="app-employment-view">
    <div>
      <ngx-skeleton-loader
        appearance="line"
        count="1"
        [theme]="{
          height: '65px'
        }"
      ></ngx-skeleton-loader>
    </div>
    @if (!isResidenceHistory) {
      <div>
        <ngx-skeleton-loader
          appearance="line"
          count="3"
        [theme]="{
          height: '65px'
        }"
        ></ngx-skeleton-loader>
      </div>
    }
  </div>
  <div class="add-new-container">
    <div >
      <ngx-skeleton-loader
        appearance="line"
        [theme]="{
          height: '45px',
          width: '98%'
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
</div>
